import ExchangeBanner from './ExchangeBanner';

export default ExchangeBanner;
